import axios, { AxiosPromise } from 'axios'
import { MChatPerguntaRespostaInput, MChatRiscoEnum } from 'graphql/types.generated'

export interface ImpressaoAcompanhamentoMChatInput {
  atendProfId: ID
  cidadaoId: ID
  resultado: number
  risco: MChatRiscoEnum
  aplicacao: Array<MChatPerguntaRespostaInput>
}

export class ImpressaoMChat {
  imprimirMChat(input: ImpressaoAcompanhamentoMChatInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/imprimirMChat', input, { responseType: 'blob' })
  }
}
